import { lazy } from "react";

export { SAVE_PRODUCT_PATH } from "./save-product-path";
export const SaveProductPage = lazy(() => import("./save-products-page"));
